exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#page[data-v-1542b9eb] {\n  border: 1px solid #c4c4c4;\n  border-radius: 25px;\n  margin: 50px;\n  background-color: #fff;\n  padding: 30px;\n}\n#header[data-v-1542b9eb] {\n  padding-bottom: 20px;\n}\n#logo[data-v-1542b9eb] {\n  float:right;\n}\n#daawn-logo[data-v-1542b9eb] {\n  height: 40px;\n}\n#task-table[data-v-1542b9eb]{\n  margin: 25px;\n  width: 90%;\n}\n.title.is-4[data-v-1542b9eb] {\n  margin: 20px 0;\n}\n\n", ""]);

// exports
